import { render, staticRenderFns } from "./PatientOverviewHN.vue?vue&type=template&id=a8b453ca&"
import script from "./PatientOverviewHN.vue?vue&type=script&lang=js&"
export * from "./PatientOverviewHN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports